import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux'
import {RootState} from '../../../../../setup'
import {useHistory} from 'react-router-dom'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import {permissions} from '../../../../../_constants/permissions'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {hasPermission} from '../../../../../_helper/hasPermission'
import {Button} from '@mui/material'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import { OCCUPATIONAL_THERAPIST_DATA_MAPPING,OCCUPATIONAL_THERAPIST_LISTING_COLOUMS,  OCCUPATIONAL_THERAPIST_SORTING_DATA} from '../../../Notes/Occupational_therapy/list/OCCUPATIONAL_THERAPIST_TABLE_CONSTANTS'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import axios from 'axios'
import dayjs from 'dayjs'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import {MoonLoader} from 'react-spinners'
import TableButton from '../../../../reusable-components/tables/TableButton'
import { toast } from 'react-toastify'

const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const  DeletedOTAssessmentList= () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [deletedID, setDeletedID] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(true)
  const [loadingStates, setLoadingStates] = useState({})
  const [hasExpiredDocuments, setHasExpiredDocuments] = useState(false)
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const timeZone = useSelector(selectTimeZone)
  const history = useHistory()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      try {
        const responseForNote = await axios.get('/otProgressNotes/getAll', {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
            isDeleted: true,
          },
        })
        const {data: noteData, currentPage, totalCounts} = responseForNote?.data
        const updatedData = noteData.map((item) => ({
          ...item,
          startDate: item?.startDate
            ? dayjs.utc(item.startDate).tz(timeZone, true).format('MM-DD-YYYY')
            : 'No details provided',
        }))
        setFilteredData(updatedData)
        setQueryData((prevState) => {
          return {
            ...prevState,
            currentPage,
            totalCounts,
          }
        })
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message);
        } else {
          console.log('Error: ', error.message);
        }
      } finally {
        setIsFetchingData(false)
      }
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
    deletedID,
  ])

  const handleView = (row: any) => {
    history.push(`/deleted-notes/occupational-therapy-notes/entry/list/${row.clientId}?noteType=${row.noteType}`)
  }

  const handleUpdate = (row: any) => {
     history.push(`/deleted-notes/occupational-therapy-notes/${row._id}`)
  }

  return (
    <div className='card'>
      <div className='card-body'>
        {isFetchingData ? (
          <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
            <MoonLoader color='#9db2fc' size={60} loading={isFetchingData} />
          </div>
        ) : (
          <div>
            <TableTitle title='Deleted OT Assessment' />
            <TableWrapper
              searchField={
                hasPermission(userPermissions, permissions.notes_occupational_therapy_note_search) && (
                <TableSearchBar
                  label='Search'
                  variant='outlined'
                  size='small'
                  value={searchTerm}
                  setQueryData={setQueryData}
                  setSearchTerm={setSearchTerm}
                  margin='normal'
                  inputAdornmentPosition='start'
                />
              )}
              dynamicTable={
                <>
                  <span className='ml-2 text-primary d-flex align-items-center gap-2'>
                    For view OT notes please click on <VisibilityOutlinedIcon /> icon in the table
                  </span>
                  <DynamicTable
                    columns={OCCUPATIONAL_THERAPIST_LISTING_COLOUMS}
                    data={filteredData}
                    canView={hasPermission(userPermissions, permissions.notes_occupational_therapy_note_view) }
                    onView={handleView}
                    canUpdate={hasPermission(userPermissions, permissions.notes_occupational_therapy_note_update) }
                    onUpdate={handleUpdate}
                    columnDataMapping={OCCUPATIONAL_THERAPIST_DATA_MAPPING}
                    sortingColumns={OCCUPATIONAL_THERAPIST_SORTING_DATA}
                    loadingStates={loadingStates}
                    setQueryData={setQueryData}
                    queryData={queryData}
                  />
                </>
              }
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DeletedOTAssessmentList
